import { ref, onMounted, onBeforeUnmount } from 'vue'
const useDetectDevice = () =>{
    const device = ref('')
    function detectDeviceByScreen() {
        const bodyElement = document.documentElement;
        const width = window.innerWidth;
        // 判断设备类型
        if (width > 767) {
            bodyElement.style.fontSize = '16px';
            return 'pc';
        } else {
            bodyElement.style.fontSize = '14px';
            return 'mb';
        }
    }
    function resizeFunction  (){
        device.value = detectDeviceByScreen();
    }
    onMounted(()=>{
        setTimeout(() => {
            device.value = detectDeviceByScreen();
            // 监听窗口大小变化
            window.addEventListener('resize', resizeFunction);
        },100)
    })
   

    onBeforeUnmount(()=>{
        window.removeEventListener('resize', resizeFunction)
    })
    return {
        device
    }
}
export default useDetectDevice